export const menus = [
	{ is_header: true, title: "Navegación Principal" },
	{ path: "/dashboard", icon: "bi bi-house", title: "Inicio" },
	{ path: "/users", icon: "bi bi-people", title: "Usuarios" },
	{ path: "/customers", icon: "bi bi-people-fill", title: "Clientes" },
	{ path: "/vehicles", icon: "bi bi-truck", title: "Vehículos" },
	{ path: "/sellers", icon: "bi bi-person-badge", title: "Vendedores" },
	{ path: "/branches", icon: "bi bi-building", title: "Sucursales" },
	{ path: "/appointments", icon: "bi bi-calendar", title: "Citas" },
	{ path: "/settings", icon: "bi bi-gear", title: "Configuración" },
];
